import * as crypto from "crypto-js";

export const encryptPassword = (password) => {
    return crypto.AES.encrypt(password, process.env.REACT_APP_SECRET_KEY).toString();
}

export const decryptPassword = (hash) => {
    return crypto.AES.decrypt(hash, process.env.REACT_APP_SECRET_KEY).toString(crypto.enc.Utf8);
}